import { useEffect, useState } from "react";
import { fetchFoundingReadiness } from "../../../../services/automapFoundingDealerApi";
import { FOUNDING_COHORT_TARGETS } from "../../../../constants/automapFoundingDealerConstants";
import { FoundingShell } from "./AdminFoundingShared";

export default function AdminFoundingReadinessPage() {
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchFoundingReadiness()
      .then(setPayload)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  const metrics = payload?.metrics;
  const checklist = payload?.cohortChecklist || [];

  return (
    <FoundingShell active="readiness" title="Readiness del cohorte" description="Metas de dealers e inventario para buyer launch.">
      {loading ? <p className="dealer-state-box">Cargando…</p> : null}
      {error ? <p className="dealer-state-box">{error}</p> : null}
      {!loading && !error && metrics ? (
        <>
          <div className="dashboard-summary-grid">
            {[
              { label: "Launch-ready", value: `${metrics.launchReadyDealers} / ${FOUNDING_COHORT_TARGETS.minLaunchReadyDealers}+` },
              { label: "Listings limpios", value: `${metrics.cleanListings} / ${FOUNDING_COHORT_TARGETS.minCleanListings}+` },
              { label: "Activos total", value: metrics.totalActiveListings },
              { label: "Fotos", value: `${metrics.photoCoveragePct}%` },
              { label: "Frescura 7d", value: `${metrics.freshnessPct}%` },
              { label: "Calidad prom.", value: metrics.averageQualityScore ?? "—" },
              { label: "Verificados", value: metrics.verifiedDealers },
              { label: "Bloqueados", value: metrics.blockedDealers },
            ].map((item) => (
              <div key={item.label} className="dashboard-summary-card">
                <span className="dashboard-summary-label">{item.label}</span>
                <strong className="dashboard-summary-value">{item.value}</strong>
              </div>
            ))}
          </div>
          <section className="dealer-state-box">
            <h3>Checklist de lanzamiento AutoMapa</h3>
            <ul>
              {checklist.map((item) => (
                <li key={item.key}>
                  {item.complete ? "✓" : "○"} {item.label} — {item.current}/{item.target}
                  {item.placeholder ? " (TODO M34)" : ""}
                </li>
              ))}
            </ul>
          </section>
        </>
      ) : null}
    </FoundingShell>
  );
}
